import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-lg bg-background-50 border border-background-200 transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title}（${movie.year}）电影海报`}
          title={`${movie.title} 高清海报`}
          className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 right-2 flex items-center gap-1 rounded-md bg-primary-950/80 px-2 py-0.5 text-xs font-medium text-accent-300">
          <i className="ri-star-fill text-accent-400"></i>
          {movie.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-3">
        <h3 className="line-clamp-1 font-heading text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
          {movie.title}
        </h3>
        <div className="mt-auto flex flex-wrap items-center gap-1.5 text-xs text-foreground-600">
          <span>{movie.year}</span>
          <span className="text-background-400">·</span>
          <span className="line-clamp-1">{movie.region}</span>
        </div>
        <div className="flex flex-wrap gap-1.5">
          {movie.types.slice(0, 3).map((type) => (
            <span
              key={type}
              className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900"
            >
              {type}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}